import { getToken, setToken, delToken, getUser, setUser, delUser, getUrlQuery, setUrlQuery, delUrlQuery } from '@/utils/storage' // getUrlQuery
import { getQueryString, getUrlParams, getPlatform } from '@/utils/index'
import { login, getWxUserInfo } from '@/api/user'
import router from '../../router'
const state = {
  token: getToken() || '',
  userInfo: getUser() || {},
  queryInfo: getUrlQuery() || {},
  orgMap: {},
  org: '',
}
const mutations = {
  setTokenInfo (state, token) {
    state.token = token
    setToken(token)
  },
  removeTokenInfo (state) {
    state.token = ''
    delToken()
  },
  setQueryInfo (state, query) {
    state.queryInfo = query
    setUrlQuery(query)
  },
  removeQueryInfo (state) {
    state.queryInfo = {}
    delUrlQuery()
  },
  setUserInfo (state, user) {
    state.userInfo = user
    setUser(user)
  },
  removeUserInfo (state) {
    state.userInfo = {}
    delUser()
  },
  setOrgMap (state, orgMap) {
    state.orgMap = orgMap
  },
  setOrg (state, org) {
    state.org = org
  }
}
const actions = {
  async getUserInfo ({ commit, state }, callback) {
    let query = getUrlParams(location.href)
    if(state.userInfo.union_id && state.queryInfo.key == query.key) {
      commit('setQueryInfo', query)
      return 
    }
    if (state.queryInfo.key !== query.key && router.currentRoute.name == 'RobotQuote') {
      commit('removeTokenInfo')
      commit('removeQueryInfo')
      commit('removeUserInfo')
    }
    // 未注册过，获取用户信息
    const code = getQueryString("code")
    
    if (code != "" && code != null) {
      commit('setQueryInfo', query)
      const mall_token = query.key
      commit('setOrg', mall_token)
      const res = await getWxUserInfo({ code, mall_token })

      const union_id = res.model
      if(!res.success || !union_id) return
      const {success, model} = await login({union_id, mall_token})
      
      if(!success || !model) return
      const token = model.phoenix_sid || ''
      delete model.phoenix_sid
      commit('setTokenInfo', token)
      commit('setUserInfo', model)
      callback && callback()
    } else {
      const platform = getPlatform()
      console.log(platform, 'platform');
      
      if(platform != 'Wechat') return
      let appId = 'wxf79a8c599651fecf';
      let redirectUri = encodeURIComponent(window.location.href); // 当前网页URL
      let authUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
      window.location.href = authUrl;  // 跳转到微信授权页面
      // localStorage.setItem('danlaile-user', JSON.stringify({"status":null,"create_time":null,"update_time":null,"count":null,"user_id":502,"parent_id":0,"org_id":null,"login_mobile":"w.","password":"8BCF2885A462E1C7FA460F6762979DE83B22A2629BA8CE5E7FD76BC09605A129","receive_phone":null,"org_dto":null,"user_type":0,"user_status":1,"union_id":"onzWswtiPgTzJsRzsPuLSEEt4Fyg","erp_customer_id":null,"new_count":null,"org_name":null,"mac_address":null,"invoice_title":null,"user_address_dto":null,"identify":502}))
      // localStorage.setItem('danlaile-url_query', JSON.stringify({"key":"0355af5c35f1a666c174c129fac72bf4","id":"89"}))
      // localStorage.setItem('danlaile-token', JSON.stringify("bebd7841-8127-442f-992d-742ed165bd8c"))
    }
  }
}
const modules = {
}

export default {
  state,
  mutations,
  actions,
  modules,
  namespaced: true
}
